module.exports = __webpack_public_path__ + "static/media/job_category_21.675cbd95.png";